var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.175,
    height: 13.631,
    viewBox: "0 0 18.175 13.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c5c5c5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.087,106.673c-4.666,0-8.823,4.85-9,5.056a.378.378,0,0,0,0,.489,18.953,18.953,0,0,0,3.836,3.311L6.3,113.156a3.028,3.028,0,0,1,3.97-3.97l1.951-1.951A9.249,9.249,0,0,0,9.087,106.673Z",
    transform: "translate(0 -106.673)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.273 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M79.862,70.6a13.883,13.883,0,0,0-4.407-3.861l2.092-2.092a.379.379,0,0,0-.535-.535L64.138,76.984a.379.379,0,0,0,0,.535.375.375,0,0,0,.267.111.38.38,0,0,0,.268-.111l2.374-2.374a8.722,8.722,0,0,0,3.795.97c4.666,0,8.823-4.85,9-5.056A.38.38,0,0,0,79.862,70.6Zm-9.02,3.245a3,3,0,0,1-1.848-.646l4.231-4.231a3.013,3.013,0,0,1-2.383,4.877Z",
    transform: "translate(-64.027 -64)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibilityOff.5bd706a3.svg";
export { ForwardRef as ReactComponent };